export const meta = {
  totalItemCurrentPage: 0,
  itemPerPage: 0,
  currentPage: 0,
  totalItem: 0,
  totalPage: 0,
}
